import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { AppEnvironmentService } from '@upr-web-primer/app-utils';
import { LocaleService } from '@upr-web-primer/locale';
import {
  LocalStorageService,
  SessionStorageService,
} from '@upr-web-primer/storage';
import { TcmService } from '@upr-web-primer/tcm-service';
import { WINDOW } from '@upr-web-primer/window';
import {
  catchError,
  distinctUntilChanged,
  firstValueFrom,
  map,
  retry,
  throwError,
} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AccountTcmService extends TcmService {
  customBaseSite: any;
  theme: any;
  siteId: any;
  tcmLocaleService: any;
  constructor(
    appEnvSrv: AppEnvironmentService,
    httpClient: HttpClient,
    localeService: LocaleService,
    sessionStorage: SessionStorageService,
    @Inject('TridionBaseUrl') tridionBaseUrl: string,
    @Inject(WINDOW) window: any,
    private http: HttpClient,
    private localStorage: LocalStorageService
  ) {
    super(
      appEnvSrv,
      httpClient,
      localeService,
      sessionStorage,
      tridionBaseUrl,
      window
    );
    this.tcmLocaleService = localeService;
  }

  override requestContentById(contentId: string): Promise<any> {
    retry;
    return firstValueFrom(
      this.getContentById(contentId).pipe(
        distinctUntilChanged(),
        retry(3),
        map((response: any) => [response[0].data]),
        catchError(() =>
          throwError(() => new Error(`Couldn't retrieve ${contentId}`))
        )
      )
    );
  }

  public getContentById(contentId: string): any {
    const loggedInUserToken = this.localStorage.getItem('oAuthToken');
    const localeObj = this.tcmLocaleService.getFromUrl();
    const lang = localeObj?.language;
    const country = localeObj?.country;
    const params = {
      ids: contentId,
      extendcl: true,
      resolvemultimedia: true,
    };
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'Accept-Language': `${lang}-${country}`,
      Authorization: `Bearer ${loggedInUserToken}`,
    });
    const url = `${environment.contentApiBaseUrl}/resort-areas/${environment?.contentIds?.TRIDION_PUBLICATION}/content`;
    return this.http.get<any>(url, { headers, params });
  }
}
